import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common';
import {
  PartnerItemApprove,
  PartnerItemCreate,
  PartnerItemDelete,
  PartnerItemInitialState,
  PartnerItemLoad,
  PartnerItemUpdate,
  CarrierShortNamesLoad,
} from './partner-item.actions';
import { PartnerItemState, PartnerItemStateModel } from './partner-item.state';
import { PartnerRequestModel } from '../models';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class PartnerItemFacade implements LoadDataFacade, SetInitialStateFacade {
  partnerData$: Observable<PartnerItemStateModel> = this.store.select(PartnerItemState.getState);
  partnerId$: Observable<number> = this.store.select(PartnerItemState.getPartnerId);
  partnerName$: Observable<string> = this.store.select(PartnerItemState.getPartnerName);
  loaded$: Observable<boolean> = this.store.select(PartnerItemState.getLoaded);
  shortNames$: Observable<string[]> = this.store.select(PartnerItemState.getShortNames);

  constructor(private store: Store) {}

  loadAll(partnerId: string): void {
    this.store.dispatch(new PartnerItemLoad(partnerId));
  }

  approvePartner(partnerId: string): void {
    this.store.dispatch(new PartnerItemApprove(partnerId));
  }

  createPartner(data: PartnerRequestModel): void {
    this.store.dispatch(new PartnerItemCreate(data));
  }

  updatePartner(data: PartnerRequestModel): void {
    this.store.dispatch(new PartnerItemUpdate(data));
  }

  deletePartners(partnerIds: number[], dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>): void {
    this.store.dispatch(new PartnerItemDelete({ dialog, partnerIds }));
  }

  setInitialState(): void {
    this.store.dispatch(new PartnerItemInitialState());
  }

  loadCarrierShortNames(): void {
    this.store.dispatch(new CarrierShortNamesLoad());
  }
}
